<template>
  <div>
    <CustomDialog
      ref="customDialog"
      v-on="$listeners"
      :title="title"
      :defaultFooter="false"
      :width="size"
      :title-height="64"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :class="[
        'c-dialog',
        $attrs.isHideFooter !== undefined
          ? $attrs.isHideFooter
            ? 'is-hide_footer'
            : ''
          : '',
      ]"
      :customClass="$attrs.customClass !== undefined ? $attrs.customClass : ''"
      :top="top"
      @on-dialog-close="onDialogClose"
    >
      <template #default>
        <component
          ref="form"
          :is="operateType"
          :operateTypeProp="operateType"
          :operateAttrProp="operateAttr"
          :formModelDataProp.sync="formModelData"
          :maxlength="maxlength"
          @on-close="
            () => {
              $refs.customDialog.onHide();
            }
          "
          v-if="isShowContent"
          v-bind="$attrs"
          @on-change-disabled="onChangeDisabled"
        ></component>
      </template>

      <template #footer>
        <div class="c-btn">
          <el-button
            type="secondary"
            size="large"
            @click="
              () => {
                $refs.customDialog.onHide();
              }
            "
            >取消</el-button
          >
          <el-button
            type="primary"
            size="large"
            class="custom_btn"
            :loading="isSubmitLoading"
            :disabled="isDisabled"
            @click="onSubmit"
            >确定</el-button
          >
        </div>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "@/components/aiChat/components/customDialog/index.vue";
import ResetNameForm from "./resetNameForm/index.vue";
import { commonMixin } from "@/components/aiChat/common/mixins.js";

export default {
  components: {
    CustomDialog,
    RESET_NAME_FORM: ResetNameForm,
  },
  data() {
    return {
      operateType: "",
      operateAttr: "batch", // 属性
      size: "",
      title: "",
      isShowContent: false,
      top: "15vh",
      formModelData: null,
      isSubmitLoading: false,
      id: null,
      isDisabled: false,
      maxlength:20,
      showWordLimit:false
    };
  },
  mixins: [commonMixin],
  methods: {
    async onShow({
      id = null,
      title = "",
      operateType = "",
      operateAttr = "batch",
      size = "30%",
      formModelData = {},
      top = "15vh",
      maxlength = 20,
      showWordLimit = false
    }) {
      this.title = title;
      this.operateAttr = operateAttr;
      this.operateType = operateType;
      this.size = size;
      this.isShowContent = true;
      this.id = id;
      this.top = top;
      this.maxlength = maxlength;
      this.showWordLimit = showWordLimit;
      console.log(this.operateType, operateAttr, formModelData, id, top);
      this.formModelData = {
        ...JSON.parse(JSON.stringify(formModelData)),
      };
      this.$refs.customDialog.onShow();
    },
    onDialogClose() {
      this.isShowContent = false;
      this.isSubmitLoading = false;
      this.title = "";
      this.operateType = "";
      this.id = null;
      this.operateAttr = "batch";
      this.formModelData = null;
      this.isDisabled = false;
    },

    onChangeDisabled(params) {
      this.isDisabled = params;
    },

    async onSubmit() {
      this.isSubmitLoading = true;
      const t = await this.$refs.form.onSubmit();
      console.log(t, "ttt");
      if (t) {
        try {
          const handle = () => {
            this.$message.success("保存成功");
            this.isSubmitLoading = false;
            let opt = {
              ...this.$refs.form.formModelData,
              operateType: this.operateType,
            };
            if (
              this.$attrs.customTypeField &&
              window.Object.keys(this.$attrs.customTypeField.value).length
            ) {
              opt = {
                ...opt,
                ...this.$attrs.customTypeField.value,
              };
            }
            this.$emit("on-update-form", opt);

            this.$refs.customDialog.onHide();
          };

          let obj = {
            ...this.$refs.form.formModelData,
          };

          switch (this.operateType) {
            case "RESET_NAME_FORM":
              let s = null;
              s = await this.onUpdateDialogue({
                chatName: obj.content,
                id: this.id,
              });
              if (s) {
                handle();
              }
              break;
          }
          this.isSubmitLoading = false;
        } catch (error) {
          this.isSubmitLoading = false;
          console.log(error);
        }
      } else {
        this.isSubmitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-dialog {
  ::v-deep .scroll_bar {
    > .el-scrollbar__wrap {
      margin-bottom: 0 !important;
    }
  }

  &.is-hide_footer {
    ::v-deep {
      .el-dialog__footer {
        display: none;
      }
      .el-dialog__body {
        padding-bottom: 24px;
      }
    }
  }

  .c-btn {
    ::v-deep .el-button {
      padding: 10px 19px;
    }
  }
}
</style>